export default __webpack_public_path__ + "static/media/blueprint--240.c770db1d.jpg";